import React from 'react';

import { useAgreementTerm } from './hooks/useAgreementTerm';

const AgreementTerm: React.FC = () => {
    const { content } = useAgreementTerm();

    return (
        <div className="relative flex size-full min-h-screen flex-col bg-white">
            <div
                className="py-12 px-10 sm:px-[8vw] bg-white break-words [&_p]:text-justify [&_h1]:text-left [&_h2]:text-left [&_h3]:text-left [&_h4]:text-left [&_li]:text-left [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5"
                dangerouslySetInnerHTML={{ __html: content }}
            ></div>
        </div>
    );
};

export default AgreementTerm;
